import { render } from "./ask-tips.html?vue&type=template&id=616469f3"
import script from "./AskTips.vue?vue&type=script&lang=ts"
export * from "./AskTips.vue?vue&type=script&lang=ts"

import "./ask-tips.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script